import ManualQuoteHtmlUI from "../components/ManualQoute/ManualQuoteHtmlUI";

// Wrapper for the alternate "HTML mock" manual-quote UI (ManualQuoteHtmlUI),
// mounted at /send-manual-quote-v2. Kept separate from ManualQuoteManagement
// (the existing send-manual-quote page) so the current production flow is
// untouched.
const ManualQuoteManagementV2 = () => {
  return <ManualQuoteHtmlUI />;
};

export default ManualQuoteManagementV2;
